var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7317 3.01865H15.728C15.237 2.14993 14.2927 1.58337 13.2352 1.58337C12.1776 1.58337 11.2333 2.14993 10.7801 3.01865H6.73863C6.02099 3.01865 5.41666 3.62298 5.41666 4.34062C5.41666 5.05826 6.02099 5.66258 6.73863 5.66258H10.7801C11.2711 6.5313 12.1776 7.09786 13.2352 7.09786C14.2927 7.09786 15.237 6.5313 15.728 5.66258H19.7694C20.4871 5.66258 21.0914 5.05826 21.0914 4.34062C21.0914 3.62298 20.4493 3.01865 19.7317 3.01865Z",
    fill: "#D5DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6491 7.92932H12.8182C10.1365 7.92932 7.98354 10.0445 7.98354 12.6508V19.2229C7.98354 20.356 8.77672 21.2625 9.87206 21.5269V19.7517C9.87206 18.052 11.3829 16.6545 13.2336 16.6545C15.0844 16.6545 16.633 18.052 16.633 19.7517V21.5269C17.6905 21.2625 18.5215 20.356 18.5215 19.2229V12.6508C18.4837 10.0447 16.293 7.92932 13.6489 7.92932H13.6491Z",
    fill: "#D5DAE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2325 18.2024C12.2127 18.2024 11.344 18.92 11.344 19.7888V23.8302C11.344 24.6989 12.1749 25.4165 13.2325 25.4165C14.2523 25.4165 15.121 24.6989 15.121 23.8302V19.751C15.121 18.8823 14.2523 18.2024 13.2325 18.2024Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.963153c0e49026c76f36b18ed580af68.svg";
export { ForwardRef as ReactComponent };